import moment from 'moment'

export default (value) => {
  if (value && moment(value).isValid() && moment().diff(value, 'years') < 100) {
    return moment(value).format('HH:mm:ss')
  } else {
    return null
  }
}
